import { EventsStoreType } from '@/types/store/events-store.type';

export const state: EventsStoreType = {
  events: null,
  event: null,
};
